const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  content: {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
    width: "100%",
  },
  contentLg: {
    maxWidth: "1180px",
    margin: "0 auto",
    padding: "20px",
    width: "100%",
  },
  contentXl: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "20px",
    width: "100%",
  },
  header: {
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 100,
    padding: "0px 30px",

    background: "#fff",
    boxShadow: "0 4px 10px -4px rgba(0,0,0,.07)",
  },
  // Opt-in full-bleed zen cream backdrop (matches the care-plan pages).
  // 68px = sticky UserHeader bar above the wrapper; without subtracting it the
  // document always scrolls ~68px past viewport-fitted pages.
  zenBackdrop: {
    background: "var(--cc-bg, #F6F5F2)",
    minHeight: "calc(100vh - 68px)",
  },
}));
